import React, { useEffect } from 'react'
import { Flex } from 'rebass'
import { useTranslation } from 'react-i18next'
import styles from './styles'
import { trackHandler } from 'uneeq-react-core'
import { VscHome } from 'react-icons/vsc'
import ReactTooltip from 'react-tooltip'

interface MayaMenuProps {
  onClick: () => void
  customStyles?: any
}
const MayaHomeButton: React.FC<MayaMenuProps> = ({ onClick, customStyles }) => {
  const { t } = useTranslation()
  const containerStyles = {
    ...styles.container,
    ...customStyles
  }

  useEffect(() => {
    ReactTooltip.rebuild()
  }, [])

  return (
    <Flex
      id="leave-session"
      data-tip={t('Tooltip.exitSessionButton')}
      sx={containerStyles}
      onClick={trackHandler(onClick, 'exit-session-btn')}
    >
      <VscHome />
    </Flex>
  )
}

export default MayaHomeButton
